import React, { useState, useEffect } from 'react';

import Select, { components } from 'react-select';

import { useForm } from 'react-hook-form';

import { GlobalContainer,
         TitleContainer,
         Title,
         SubTitleContainer,
         SubTitle,
         Text,
         ContentContainer,
         ContentContainer1,
         ContentContainer11,
         ContentContainer12,
         ContentContainer2,
         ContentContainer3,
         ContentContainer4,
         ContentContainer21,
         ContentContainer22,
         ContentContainer14,
         ContentContainer1WithoutMargin,
         ContentContainerForm,
         DescContainer,
         TextDesc,
         FileInputDiv,
         FileContent,
         Line,
         Col1,
         Col2,
         Col3,
         Col4,
         Text2,
         SelectContainer,
         ContentContainerButtons } from './styles';
import MessageAlert from '../../Components/Messages/Alert/index';
import ModalConfirm from '../../Components/Modal/Confirm/index';
import ModalCancel from '../../Components/Modal/Cancel/index';
import ModalError from '../../Components/Modal/Warn/index';
import ModalWarn from '../../Components/Modal/Warn/index';
import ModalMessage from '../../Components/Modal/Message/index'

//import '../../../node_modules/@govbr/dsgov/dist/dsgov.min.css';

import InfoIcon from '../../assets/info_icon.png';
import FailIcon from '../../assets/fail_icon.png';
import FailIconRed from '../../assets/fail_icon_red.png';
import SuccessIcon from '../../assets/success_icon.png';
import UploadIcon from '../../assets/upload_icon.png'
import TrashIcon from '../../assets/trash_icon.png'
import DropDownIcon from '../../assets/drop_down_icon.png';
import DropUpIcon from '../../assets/drop_up_icon.png';
import { cpfMask } from '../../utils';
import { saveFile, readFile, cleanupExpired, clearSessionFiles } from '../../indexedDbService';
import filesize from 'filesize'

const cellMask = (cell) => {
    var num = cell?.replace(/[^\d]/g, ''); //remove todos os caracteres não numéricos
    var len = num?.length; //guarda o número de digitos até o momento

    if(len <= 2){
        cell = num?.replace(/(\d{1,2})/g, '($1');
    }else if(len <= 7){
        cell = num?.replace(/(\d{2})(\d{0,5})/g, '($1) $2');
    }else{
        cell = num?.replace(/(\d{2})(\d{5})(\d{1,4})/g, '($1) $2-$3');
    }
    return cell;
}

export default function CitizenData(props) {
    const [loadCitizen, setLoadCitizen] = useState(false);

    const [ loading, setLoading ] = useState(false);

    const [ modalError, setModalError ] = useState(false);
    const [ modalErrorFinish, setModalErrorFinish ] = useState(false);
    // Para exibir mensagens de erro do Acesso
    const [ modalErrorAcesso, setModalErrorAcesso ] = useState(false);
    const [ textError, setTextError ] = useState('');
    
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    const [citizenOrAttorneyBiometricValidated, setCitizenOrAttorneyBiometricValidated] = useState(false);
    const [citizenUploadedDocumentation, setCitizenUploadedDocumentation] = useState(false);

    const operationEnum = {
        CITIZENORATTORNEY_FINGERPRINTVERIFY: 'CITIZENORATTORNEY_FINGERPRINTVERIFY',
        ATTENDANT_FINGERPRINTVERIFYANDGENERATEPASSWORD: 'ATTENDANT_FINGERPRINTVERIFYANDGENERATEPASSWORD'
    }

    const [citizen, setCitizen] = useState({
        id_attendance: '',
        attendent: '',
        cpf_attendant: '',
        person: '',
        ident_dig: '',
        cpf: '',
        name: '',
        social_name: '',
        birth_date: '',
        mothers_name: '',
        email: '',
        cell: '',
        documents: '',
        document_list: '',
        document_type: '',
        last_id_list: ''
    });

    const [attorney, setAttorney] = useState({
        name_attorney: '',
        cpf_attorney: ''
    });

    const [citizenOrAttorneyBiometricOptional, setCitizenOrAttorneyBiometricOptional] = useState(false);
    const [citizenOrAttorneyBiometricDoNotExist, setCitizenOrAttorneyBiometricDoNotExist] = useState(false);
    const [nCitizenOrAttorneyBiometricAttempt, setNCitizenOrAttorneyBiometricAttempt] = useState(1);

    const [citizenFileName, setCitizenFileName] = useState();
    const [citizenFileSize, setCitizenFileSize] = useState();
    const [citizenFileType, setCitizenFileType] = useState();
    const [msgFileError, setMsgFileError] = useState();
    const [documentTypeListOptions, setDocumentTypeListOptions] = useState();
    const [chosenDocumentType, setChosenDocumentType] = useState();

    const SelecStyles = {
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            borderWidth: state.isFocused ? 2.5 : 1,
            borderColor: state.isFocused ? '#E60000' : '#888',
            '&:hover': {
                backgroundColor: '#C5D4EB',
            },
            marginTop: 6,
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            fontSize: 13.5,
            fontWeight: 355,
            marginLeft: 7,
            fontStyle: 'italic',
        }),
    }
    const DropdownIndicator = (props) => {
      return (
          <components.DropdownIndicator {...props}>
              {props.selectProps.menuIsOpen 
                  ? <img src={DropUpIcon} alt="upicon" />
                  : <img src={DropDownIcon} alt="downicon"/>
              }
          </components.DropdownIndicator>
      );
    };
    const IndicatorSeparator = ({ innerProps }) => {
        return <span style={{}} {...innerProps} />;
    };

    useEffect(() => {

        removeUploadedFile(removeUploadedFileOperationEnum.EXPIRED); //Limpa qualquer arquivo que tenha ultrapassado sua data de expiração.

        if (!loadCitizen && props.location.state !== undefined) {
            setCitizen({
                id_attendance: props.location.state.id_attendance,
                attendent: props.location.state.attendent,
                cpf_attendant: props.location.state.cpf_attendant,
                person: props.location.state.person,
                ident_dig: props.location.state.ident_dig,
                cpf: props.location.state.cpf,
                selo_conta: props.location.state.selo_conta,
                name: props.location.state.name,
                social_name: props.location.state.social_name,
                birth_date: props.location.state.birth_date,
                mothers_name: props.location.state.mothers_name,
                email: props.location.state.email,
                cell: props.location.state.cell,
                documents: props.location.state.documents,
                document_list: props.location.state.document_list,
                document_type: props.location.state.document_type,
                last_id_list: props.location.state.last_id_list,
                fingerprint_verify: props.location.state.fingerprint_verify
            });

            setAttorney({
                name_attorney: props.location.state.name_attorney,
                cpf_attorney: props.location.state.cpf_attorney,
            });

            setLoadCitizen(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.state, props, loadCitizen]);

    const { register, handleSubmit, errors } = useForm();
    const { person, ident_dig, cpf, selo_conta, name, social_name, birth_date, mothers_name, email, cell, fingerprint_verify } = citizen;

    const [ isModalConfirmVisible, setModalConfirmVisible ] = useState(false);
    const [ isModalCancelVisible, setModalCancelVisible ] = useState(false);
    const [ isModalFingerprintVerify, setModalFingerprintVerify ] = useState(false);

    const actionButtonModalConfirmCancel = () => {
        setModalConfirmVisible(false);
    };

    const actionButtonModalCancelCancel = () => {
        setModalCancelVisible(false);
    };

    const citizenOrAttorneyFingerprintVerify = async (digital_jwe, type) => {
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_atendente: citizen.cpf_attendant,
                id_atendimento:  citizen.id_attendance,
                digital_jwe: digital_jwe,
                type: type
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/atendimento/validaCapturaBiometricaCidadao`, requestOptions).then(function(response) {
            if (response.ok) {
                response.json().then(function() {
                    setLoading(false);
                    setCitizenOrAttorneyBiometricValidated(true);
                });
            } else if (response.status === 422) {
                //CASO O ATENDIMENTO JA ESTEJA FINALIZADO:
                response.json().then(function(data) { 
                    if (data.errorCode === "04") {
                        setLoading(false);
                        setModalConfirmVisible(false);
                        setModalErrorFinish(true);
                    }else if (data.errorCode === "12") { //exibir mensagem de erro do Acesso
                        let n = nCitizenOrAttorneyBiometricAttempt + 1;
                        setCitizenOrAttorneyBiometricOptional(n > 5);
                        setNCitizenOrAttorneyBiometricAttempt(n);
                        setLoading(false);
                        setModalConfirmVisible(false);
                        setModalErrorAcesso(true);
                        setTextError(data.message);
                    } else if (data.errorCode === 'DIGITAL_MUSTEXIST') {
                        setCitizenOrAttorneyBiometricDoNotExist(true);
                        setLoading(false);
                        setModalConfirmVisible(false);
                        setModalErrorAcesso(true);
                        setTextError(data.message);
                    } else {                      
                        setLoading(false);
                        setModalConfirmVisible(false);
                        setModalError(true);
                    }
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                    setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                    setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                    setLoading(false)
                    setModalInvalidSessionError(true)
                })
                } else  {
                // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                setLoading(false);
                setModalConfirmVisible(false);
                setModalError(true);
            }
        }).catch(function(err) {
            setLoading(false);
            setModalConfirmVisible(false);
            setModalError(true);
            console.error('Failed retrieving information', err);
        });
    }

    const actionButtonGeneratePassword = async (digital_jwe, type) => {

        setLoading(true);

        // GERAR SENHA ATENDIMENTO
        var passwordGenerate = '';

        // SE FOR FLUXO CIDADAO
        if (citizen.person === "cidadao") {
            try {
                let citizenDocBase64;
                let citizenTipoDoc;
                if (citizenUploadedDocumentation) {
                    const record = await readFile();                    
                    citizenDocBase64 = record.data;
                    citizenTipoDoc = chosenDocumentType.value;
                }

                const requestOptions = {
                    method: 'PUT',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                        'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
                    }),
                    body: JSON.stringify({
                        id_atendimento:  citizen.id_attendance,
                        nome_cidadao: citizen.name,
                        email_cidadao: citizen.email,
                        celular_cidadao: citizen.cell,
                        nome_atendente: citizen.attendent,
                        cpf_atendente: citizen.cpf_attendant,
                        digital_jwe: digital_jwe,
                        type: type,
                        citizen_doc_base64: citizenDocBase64,
                        citizen_tipo_doc: citizenTipoDoc
                    }),
                };
                await fetch(`${process.env.REACT_APP_API_URL}/atendimento/finaliza`, requestOptions).then(function(response) {
                    if (response.ok) {
                        response.json().then(function(data) {
                            // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!

                            if (data.senha_provisoria){
                                passwordGenerate = data.senha_provisoria

                                setLoading(false);
                                props.history.push(
                                    "/senhaprovisoria", 
                                    {id_attendance: citizen.id_attendance,
                                    citizen_person: citizen.person,
                                    citizen_name: citizen.name, 
                                    citizen_cpf: citizen.cpf,
                                    citizen_cell: citizen.cell, 
                                    citizen_email: citizen.email, 
                                    password: passwordGenerate,
                                    ident_dig: citizen.ident_dig}
                                );  
                            } else {
                                setLoading(false);
                                setModalConfirmVisible(false);
                                setModalError(true);
                            }
                        });
                    } else if (response.status === 422) {
                        //CASO O ATENDIMENTO JA ESTEJA FINALIZADO:
                        response.json().then(function(data) {
                            if (data.errorCode === "04") {
                                setLoading(false);
                                setModalConfirmVisible(false);
                                setModalErrorFinish(true);
                            }else if (data.errorCode === "12") { //exibir mensagem de erro do Acesso
                                setLoading(false);
                                setModalConfirmVisible(false);
                                setModalErrorAcesso(true);
                                //alert(data.message);
                                setTextError(data.message);
                            } else {
                                setLoading(false);
                                setModalConfirmVisible(false);
                                setModalError(true);
                            }
                        });
                    } else if (response.status === 403) {
                        response.json().then(function (data) {
                        setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                        setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                        setLoading(false)
                        setModalInvalidSessionError(true)
                        })
                    } else  {
                        // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                        setLoading(false);
                        setModalConfirmVisible(false);
                        setModalError(true);
                    }
                });
            } catch (err) {
                setLoading(false);
                setModalConfirmVisible(false);
                setModalError(true);
            } finally {
                await removeUploadedFile(); //Garantia absoluta de limpeza
            }
        } 
        // FLUXO PROCURADOR
        else {
            const requestOptions = {
                method: 'PUT',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    id_atendimento:  citizen.id_attendance,
                    cpf_cidadao: citizen.cpf,
                }),
            };
            await fetch(`${process.env.REACT_APP_API_URL}/atendimento/procuracao/cidadao`,
                        requestOptions
            ).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!

                        if (data.message){
                            
                            // AQUI O CIDADAO FOI ASSOCIADO AO PROCURADOR

                            // AGORA VAMOS ANEXAR OS DOCUMENTOS (ANEXAR REQUEST)
                            var documentsList = [];
                            var obj = {};

                            citizen.documents.forEach(doc => {
                                obj = {
                                    tipo_doc: doc.type,
                                    documento: doc.file,
                                };

                                documentsList.push(obj);
                            });

                            //console.log('Document List (Body) ->', documentsList);

                            const requestOptions = {
                                method: 'PUT',
                                headers: new Headers({
                                    'Content-Type': 'application/json',
                                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
                                }),
                                body: JSON.stringify({
                                    id_atendimento: citizen.id_attendance,
                                    documento: documentsList,
                                }),
                            };
                            
                            fetch(`${process.env.REACT_APP_API_URL}/documentos/anexa`,
                                        requestOptions
                            ).then(function(response) {
                                if (response.ok) {
                                    response.json().then(function(data) {
                                        // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!

                                        if (data.Mensagem){
                                            // ANEXOU COM SUCESSO OS DOCUMENTOS

                                            // AGORA FINALIZA O ATENDIMENTO
                                            const requestOptions = {
                                                method: 'PUT',
                                                headers: new Headers({
                                                    'Content-Type': 'application/json',
                                                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                                                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
                                                }),
                                                body: JSON.stringify({
                                                    id_atendimento:  citizen.id_attendance,
                                                    nome_cidadao: citizen.name,
                                                    email_cidadao: citizen.email,
                                                    celular_cidadao: citizen.cell,
                                                    nome_atendente: citizen.attendent,
                                                    cpf_atendente: citizen.cpf_attendant,
                                                    digital_jwe: digital_jwe,
                                                    type: type
                                                }),
                                            };
                                            fetch(`${process.env.REACT_APP_API_URL}/atendimento/finaliza`,
                                                        requestOptions
                                            ).then(function(response) {
                                                if (response.ok) {
                                                    response.json().then(function(data) {
                                                        // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!
                                
                                                        if (data.senha_provisoria){
                                                            passwordGenerate = data.senha_provisoria
                                
                                                            setLoading(false);
                                                            props.history.push(
                                                                "/senhaprovisoria", 
                                                                {id_attendance: citizen.id_attendance,
                                                                citizen_person: citizen.person,
                                                                citizen_name: citizen.name, 
                                                                citizen_cpf: citizen.cpf,
                                                                citizen_cell: citizen.cell, 
                                                                citizen_email: citizen.email, 
                                                                password: passwordGenerate,
                                                                ident_dig: citizen.ident_dig}
                                                            );  
                                                        } else {
                                                            setLoading(false);
                                                            setModalConfirmVisible(false);
                                                            setModalError(true);
                                                            console.log('Response error in atendimento/finaliza BackendBalcao');
                                                        }
                                                    });
                                                } else if (response.status === 422) {
                                                    //CASO O ATENDIMENTO JA ESTEJA FINALIZADO
                                                    response.json().then(function(data) {
                                                        if (data.errorCode === "04") {
                                                            setLoading(false);
                                                            setModalConfirmVisible(false);
                                                            setModalErrorFinish(true);
                                                        }else if (data.errorCode === "12") { //exibir mensagem de erro do Acesso
                                                            setLoading(false);
                                                            setModalConfirmVisible(false);
                                                            setModalErrorAcesso(true);
                                                            //alert(data.message);
                                                            setTextError(data.message);
                                                        } else {
                                                            setLoading(false);
                                                            setModalConfirmVisible(false);
                                                            setModalError(true);
                                                            console.log('Error in atendimento/finaliza BackendBalcao: '+data.message);
                                                        }
                                                    });
                                                } else if (response.status === 403) {
                                                    response.json().then(function (data) {
                                                      setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                                                      setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                                                      setLoading(false)
                                                      setModalInvalidSessionError(true)
                                                    })
                                                  } else {
                                                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                                                    setLoading(false)
                                                    setModalConfirmVisible(false)
                                                    setModalError(true)
                                                    console.log('Request error in atendimento/cidadao BackendBalcao')
                                                }
                                            }).catch(function(err) {
                                                setLoading(false);
                                                setModalConfirmVisible(false);
                                                setModalError(true);
                                                console.error('Failed retrieving information', err);
                                            });                                            

                                        } else {
                                            setLoading(false);
                                            setModalConfirmVisible(false);
                                            setModalError(true);
                                            console.log('Response error in documentos/anexa BackendBalcao');
                                        }
                                    });
                                } else if (response.status === 422) {
                                    //CASO O ATENDIMENTO JA ESTEJA FINALIZADO
                                    response.json().then(function(data) {
                                        if (data.errorCode === "04") {
                                            setLoading(false);
                                            setModalConfirmVisible(false);
                                            setModalErrorFinish(true);
                                        }else if (data.errorCode === "12") { //exibir mensagem de erro do Acesso
                                            setLoading(false);
                                            setModalConfirmVisible(false);
                                            setModalErrorAcesso(true);
                                            //alert(data.message);
                                            setTextError(data.message);
                                        } else {
                                            setLoading(false);
                                            setModalConfirmVisible(false);
                                            setModalError(true);
                                            console.log('Error in documentos/anexa BackendBalcao: '+data.message);
                                        }
                                    });
                                } else if (response.status === 403) {
                                    response.json().then(function (data) {
                                      setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                                      setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                                      setLoading(false)
                                      setModalInvalidSessionError(true)
                                    })
                                  } else {
                                        // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                                        setLoading(false);
                                        setModalConfirmVisible(false);
                                        setModalError(true);
                                        console.log('Request error in documentos/anexa BackendBalcao');
                                }
                            }).catch(function(err) {
                                setLoading(false);
                                setModalConfirmVisible(false);
                                setModalError(true);
                                console.error('Failed retrieving information', err);
                            });
                        } else {
                            setLoading(false);
                            setModalConfirmVisible(false);
                            setModalError(true);
                            console.log('Response error in atendimento/procuracao/cidadao BackendBalcao');
                        }
                    });
                } else {
                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                    setLoading(false);
                    setModalConfirmVisible(false);
                    setModalError(true);
                    console.log('Request error in atendimento/procuracao/cidadao BackendBalcao');
                }
            }).catch(function(err) {
                setLoading(false);
                setModalConfirmVisible(false);
                setModalError(true);
                console.error('Failed retrieving information', err);
            });
        }
    };

    const actionButtonCitizenOrAttorneyFingerprintVerify = () => {
        startFingerprintScan(operationEnum.CITIZENORATTORNEY_FINGERPRINTVERIFY);
    }

    const actionButtonFingerprintVerifyAndGeneratePassword = () => {
        startFingerprintScan(operationEnum.ATTENDANT_FINGERPRINTVERIFYANDGENERATEPASSWORD);
    }

    const startFingerprintScan = async (operation) => {
        setLoading(true);
        
        setModalFingerprintVerify(true);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_cidadao: citizen.cpf,
                cpf_atendente: citizen.cpf_attendant,
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/atendimento/iniciaCapturaBiometrica`, requestOptions)
           .then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) { //TODO Deve retornar o dado criptografado pela chave pública do middleware
                        actionFingerprintScanner(data.iat, data.publicKey, operation);
		            });
		        } else if (response.status === 422) {
                    response.json().then(function(data) {
                        setTextError(data.message);
                        setModalErrorAcesso(true);
                        setLoading(false);
                        setModalFingerprintVerify(false);
                    });
		        } else if (response.status === 403) {
                    response.json().then(function (data) {
                      setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                      setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                      setLoading(false)
                      setModalInvalidSessionError(true)
                      setModalErrorAcesso(false)
                      setModalFingerprintVerify(false)
                    })
                  } else {
                    setLoading(false);
                    setModalConfirmVisible(false);
                    setModalError(true);
                    setModalFingerprintVerify(false);
                    setModalErrorAcesso(false);
                  }
 	        }).catch(function(err) {
                setLoading(false);
                setModalConfirmVisible(false);
                setModalError(true);
                setModalFingerprintVerify(false);
                setModalErrorAcesso(false)
            });
    }

    const actionFingerprintScanner = async (iat, publicKey, operation) => {
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                iat:  iat,
                publicKey: publicKey
            }),
        };
        await fetch(`http://localhost:5000/capture`, requestOptions)
           .then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        if (operation === operationEnum.CITIZENORATTORNEY_FINGERPRINTVERIFY) {
                            citizenOrAttorneyFingerprintVerify(data.jwe, data.type);
                        }
                        if (operation === operationEnum.ATTENDANT_FINGERPRINTVERIFYANDGENERATEPASSWORD) {
                            actionButtonGeneratePassword(data.jwe, data.type);
                        }
                        setModalFingerprintVerify(false);
		            });
		        } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (data.code === "E003") {
                            setTextError("Falha ao capturar a digital. Por favor, posicione o dedo corretamente sobre o sensor.");
                            setModalErrorAcesso(true);
                        } else {
                            setTextError(data.message);
                            setModalErrorAcesso(true);
                        }
                        setLoading(false);
                        setModalConfirmVisible(false);
                        setModalFingerprintVerify(false);
                    });
		        } else {
                    setLoading(false);
                    setModalConfirmVisible(false);
                    setModalFingerprintVerify(false);
                }
 	        }).catch(function(err) {
                setTextError('Por favor, verifique se o serviço "Govbr Fingerprint" está em execução e se o seu browser não está bloqueando o serviço.');
                setModalErrorAcesso(true);
                setLoading(false);
                setModalConfirmVisible(false);
                setModalFingerprintVerify(false);
            });
    }

    const removeInputMask = (cell) => {
        if (cell === "") {
            return ""
        } else {
            return cell.replace(/[^\d]+/g, "");
        }
    };

    const onSubmit = (data) => {

        //console.log(data);
        //console.log(citizen);

        data.cell = removeInputMask(data.cell);

        setCitizen({
            ...citizen, 
            email: data.email,
            cell: data.cell
        });

        setModalConfirmVisible(true);
    };

    useEffect(() => {
        const typeListOptions = [
            {value: 1, label: 'Identidade do Cidadão'},
            {value: 99, label: 'Outros'}
        ];
        setDocumentTypeListOptions(typeListOptions);
        setChosenDocumentType(typeListOptions[0]);

        removeUploadedFile(); // Limpa imediatamente todos os arquivos armazenados no indexeddb sempre que a página carrega

        //O "beforeunload" é um evento do browser que dispara quando a página está prestes a ser descarregada (Fecha a aba ou o browser, Atualiza a página (F5 / Ctrl+R), Navega para outro site,
        // Troca a URL, Recarrega por código (location.reload())).
        window.addEventListener('beforeunload', clearSessionFiles);
        return () => window.removeEventListener('beforeunload', clearSessionFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const uploadCitizenDocument = async (e) => {
        const MAX_FILE_SIZE = 5 * 1024 * 1024; // Limita o tamanho máximo do arquivo a 5MB.
        const FILE_TYPE = 'application/pdf'; //Limita o tipo de arquivo que deve ser usado.

        const file = e.target.files[0];
        if (!file) return;

        if (file.size > MAX_FILE_SIZE) {
            setMsgFileError('O arquivo deve ter no máximo 5MB');
            e.target.value = ''; // limpa o input
            return;
        }

        if (!file.type?.toLowerCase().includes(FILE_TYPE)) {
            setMsgFileError('O arquivo deve ser um PDF');
            e.target.value = ''; // limpa o input
            return;
        }

        const reader = new FileReader()

        reader.onloadend = async () => {
            const base64 = reader.result
            
            await saveFile(base64, file.name, file.size, file.type);

            const record = await readFile();

            if (record) { //Confirma se o arquivo foi realmente salvo no browser
                setMsgFileError(undefined);
                setCitizenFileType(record.type);
                setCitizenFileName(record.name);
                setCitizenFileSize(filesize(record.size));
                setCitizenUploadedDocumentation(true);
            } else {
                setCitizenFileType(undefined);
                setCitizenFileName(undefined);
                setCitizenFileSize(undefined);
                setCitizenUploadedDocumentation(false);
            }
            setMsgFileError(undefined);
            e.target.value = ''; // limpa o input. Necessário para possibilitar que o usuário escolha o mesmo arquivo (acionando o evento 'onChange') em caso de algum erro.
        };

        reader.readAsDataURL(file)
    };

    const removeUploadedFileOperationEnum = {
        NOW: 'NOW',
        EXPIRED: 'EXPIRED'
    }
    // Realiza a limpeza dos arquivos
    const removeUploadedFile = async (operation) => {

        if (operation === removeUploadedFileOperationEnum.EXPIRED) {
            await cleanupExpired(); //Limpa apenas os arquivos que se encontram expirados.
        } else {
            await clearSessionFiles(); //Limpa imediatamente todos os arquivos armazenados no indexeddb sempre que a página carrega.
        }
                
        //Confirma se a limpeza foi feita. Importante para evitar que um mesmo arquivo seja usado repetidas vezes por conta de qualquer erro.
        const record = await readFile();
        if (record) {
            setCitizenFileType(record.type);
            setCitizenFileName(record.name);
            setCitizenFileSize(filesize(record.size));
            setCitizenUploadedDocumentation(true);
        } else {
            setCitizenFileType(undefined);
            setCitizenFileName(undefined);
            setCitizenFileSize(undefined);
            setCitizenUploadedDocumentation(false);
        }
        setMsgFileError(undefined);
    }

    return (
        <>
            {!loadCitizen ?
                <div style={{'marginTop': '75px'}}><h1> Error on the page! </h1></div>
            :
                <>
                    <ModalConfirm 
                        id="modalconfirmalert"
                        appear={isModalConfirmVisible}
                        title={
                            person === "cidadao" ?
                                "Confirmar Identificação do Cidadão"
                            :
                                "Confirmar Identificação do Procurador"
                        }
                        text={
                            person === "cidadao" ?
                                "Confirmo que identifiquei o cidadão devidamente, mediante apresentação de documento original de identificação válido e oficial."
                            :
                                "Confirmo que identifiquei devidamente o procurador, mediante apresentação da procuração assinada e documento original de identificação válido e oficial."
                        }
                        textButton1={"Cancelar"}
                        textButton2={"Confirmar"}
                        actionButton1={actionButtonModalConfirmCancel}
                        load={loading}
                        actionButton2={() => {
                            if (fingerprint_verify && !citizenOrAttorneyBiometricValidated) {
                                actionButtonFingerprintVerifyAndGeneratePassword();
                            } else {
                                actionButtonGeneratePassword();
                            }
                        }
                    }
                    />

                    <ModalCancel
                        id="modalcancelalert"
                        appear={isModalCancelVisible}
                        text={"Tem certeza que deseja cancelar o atendimento?"}
                        actionButton1={actionButtonModalCancelCancel}
                        actionButton2={() => props.history.push("/pesquisarcidadao")}
                    />

                    <ModalError
                        id="modalconfirmalert"
                        appear={modalError}
                        text = 'Houve algum problema no servidor. Aguarde um momento e tente novamente.'
                        textButton2='Ok'
                        actionButton2={() => setModalError(false)}
                    />

                    <ModalError
                        id="modalconfirmalert"
                        appear={modalErrorAcesso}
                        text = {textError}
                        textButton2='Ok'
                        actionButton2={() => setModalErrorAcesso(false)}
                    />

                    <ModalError
                        id="modalconfirmalert"
                        appear={modalErrorFinish}
                        text = 'Este atendimento já foi finalizado. Todo atendimento deve ser iniciado da Página Inicial.'
                        textButton2='Ok'
                        actionButton2={() => {
                            setModalErrorFinish(false);
                            props.history.push("/pesquisarcidadao")
                        }}
                    />
                    
                    <ModalWarn
                        id='modalWarnalertInvalidSession'
                        appear={modalInvalidSessionError}
                        title = { modalInvalidSessionErrorTitle }
                        text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                        textButton2='Ir para tela inicial'
                        actionButton2={() => { 
                        document.getElementById("btnLogout").click();
                        }}
                    />

                    <ModalMessage
                        id='ModalFingerprintVerify'
                        appear={isModalFingerprintVerify}
                        title = 'Lendo a digital...'
                        text= 'Por favor, coloque um dos seus dedos sobre o sensor para que possamos validar a sua digital.'
                    />
                    
                    <GlobalContainer>
                        <MessageAlert cpf={cpf} ident_dig={ident_dig}/>

                        <TitleContainer>
                            <Title> {
                                !ident_dig ? 
                                    'Criar Conta gov.br e Gerar Senha Provisória'
                                :
                                    'Atualizar Conta gov.br e Gerar Senha Provisória'
                            } </Title>
                        </TitleContainer>

                        <SubTitleContainer>
                            <SubTitle> Dados do Cidadão </SubTitle>
                        </SubTitleContainer>

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <ContentContainer>
                                <ContentContainer1>
                                    <ContentContainer11>
                                        <label> CPF </label>
                                        <Text> 
                                            { cpfMask(cpf) }
                                        </Text>
                                    </ContentContainer11>

                                    <ContentContainer12>
                                        <label> Data Nascimento </label>
                                        <Text> 
                                            {birth_date.slice(-2)}/{birth_date.slice(4,6)}/{birth_date.slice(0,4)} 
                                        </Text>
                                    </ContentContainer12>

                                    <ContentContainer12>
                                        <label> Nível da conta </label>
                                        <Text> 
                                            {selo_conta ? selo_conta : 'Não possui'}
                                        </Text>
                                    </ContentContainer12>
                                </ContentContainer1>

                                <ContentContainer2>
                                    <ContentContainer21>
                                        <label> Nome </label>
                                        <Text> {social_name ? social_name : name} </Text>
                                    </ContentContainer21>

                                    <ContentContainer22>
                                        <label> Nome da Mãe </label>
                                        <Text> {mothers_name} </Text>
                                    </ContentContainer22>
                                </ContentContainer2>
                            </ContentContainer>

                            {person === "procurador" && 
                                <>
                                    <SubTitleContainer>
                                        <SubTitle>
                                            Contatos relacionados
                                        </SubTitle>
                                    </SubTitleContainer>

                                    <DescContainer>
                                        <TextDesc>
                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                <img
                                                    src={InfoIcon}
                                                    style = {{ paddingBottom: '5px', marginRight: '9px' }}
                                                    alt="infoicon"
                                                />
                                            </i>
                                            Os contatos informados serão utilizados para o recebimento da senha provisória e para futuras recuperações da Conta gov.br. 
                                        </TextDesc>
                                    </DescContainer>
                                </>
                            }

                            <ContentContainer>
                                <ContentContainer1>
                                    <ContentContainer11>
                                        <div className="br-input">
                                            <label htmlFor="email">E-mail</label>
                                            <input
                                                ref={register({ 
                                                    required: false, 
                                                    pattern: {value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, message: "Digite um e-mail válido."}
                                                })} 
                                                id="email"
                                                name='email'
                                                type="text" 
                                                placeholder="Digite o email"
                                                defaultValue={email}
                                                onChange={(event) => setCitizen({ ...citizen, email: event.target.value })}
                                            />
                                        </div>
                                        {errors?.email && 
                                            <span className="feedback danger" role="alert">
                                                <i className="fas fa-times-circle" aria-hidden="true">
                                                    <img
                                                        src={FailIcon}
                                                        style = {{ paddingBottom: '5px' }}
                                                        alt="failicon"
                                                    />
                                                </i>
                                                <label>{errors.email.message}</label>
                                            </span>
                                        }
                                    </ContentContainer11>

                                    <ContentContainer12>
                                        <div className="br-input">
                                            <label htmlFor="cell">Celular</label>
                                            <input
                                                id="cell"
                                                name="cell"
                                                placeholder="Digite somente números com o DDD "
                                                type="text"
                                                maxLength="15"
                                                defaultValue={cellMask(cell)}
                                                ref={register({
                                                    required: false,
                                                    minLength: { value: 15, message: 'Número inválido.' },
                                                    maxLength: { value: 15, message: 'Número inválido' }
                                                })}
                                                onChange={(event) => {
                                                    const {value} = event.target
                                                    setCitizen({ ...citizen, cell: removeInputMask(value) })
                                                    event.target.value = cellMask(value)
                                                }}
                                            />
                                        </div>
                                        {errors?.cell &&
                                            <span  className="feedback danger" role="alert">
                                                <i className="fas fa-times-circle" aria-hidden="true">
                                                    <img
                                                        src={FailIcon}
                                                        style = {{ paddingBottom: '5px' }}
                                                        alt="failicon"
                                                    />
                                                </i>
                                                <label>{errors.cell.message}</label>
                                            </span>
                                        }
                                    </ContentContainer12>
                                </ContentContainer1>

                                <ContentContainer2>

                                </ContentContainer2>
                            </ContentContainer>

                            {fingerprint_verify && 
                                <>
                                    <SubTitleContainer>
                                        <SubTitle>
                                            {!(person === "procurador") && ('Biometria do Cidadão')}
                                            {(person === "procurador") && ('Biometria do Procurador')}
                                        </SubTitle>
                                    </SubTitleContainer>

                                    <DescContainer>
                                        <TextDesc>
                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                <img
                                                    src={InfoIcon}
                                                    style = {{ paddingBottom: '5px', marginRight: '9px' }}
                                                    alt="infoicon"
                                                />
                                            </i>
                                            {!(person === "procurador") && ('Antes de continuar é necessário validar a biometria do cidadão. Caso o cidadão não possua digitais cadastradas ou após 5 tentativas, será permitido o atendimento mediante a identificação das digitais do atendente.')}
                                            {(person === "procurador") && ('Antes de continuar é necessário validar a biometria do procurador. Caso o procurador não possua digitais cadastradas ou após 5 tentativas, será permitido o atendimento mediante a identificação das digitais do atendente.')}
                                        </TextDesc>
                                    </DescContainer>
                                    <ContentContainer>
                                        <ContentContainer1>
                                            <button className={`br-button primary ${loading ? ' loading ' : ''} `}type="button" disabled={citizenOrAttorneyBiometricValidated || citizenOrAttorneyBiometricDoNotExist || loading} onClick={() => actionButtonCitizenOrAttorneyFingerprintVerify()}>
                                                Iniciar a validação
                                            </button>
                                            <span style={{fontSize: '.9em', marginLeft: '10%'}}>( {nCitizenOrAttorneyBiometricAttempt}&#170; tentativa )</span>
                                        </ContentContainer1>
                                        <ContentContainer14>
                                            {citizenOrAttorneyBiometricValidated && (
                                                <TextDesc>
                                                    <i aria-hidden="true">
                                                        <img
                                                            src={SuccessIcon}
                                                            style = {{ paddingBottom: '5px', marginRight: '9px' }}
                                                            alt="successIcon"
                                                        />
                                                    </i>
                                                    {!(person === "procurador") && (<span>Digital do cidadão validada.</span>)}
                                                    {(person === "procurador") && (<span>Digital do procurador validada.</span>)}
                                                </TextDesc>
                                            )}
                                            {citizenOrAttorneyBiometricDoNotExist && (
                                                <TextDesc>
                                                    <i aria-hidden="true">
                                                        <img
                                                            src={FailIconRed}
                                                            style = {{ paddingBottom: '5px', marginRight: '9px' }}
                                                            alt="failIcon"
                                                        />
                                                    </i>
                                                    {!(person === "procurador") && (<span>O cidadão não possui digitais cadastradas.</span>)}
                                                    {(person === "procurador") && (<span>O procurador não possui digitais cadastradas.</span>)}
                                                </TextDesc>
                                            )}                                            
                                        </ContentContainer14>
                                    </ContentContainer>

                                    <br></br>

                                    {(!(person === "procurador") && (!citizenOrAttorneyBiometricValidated && (citizenOrAttorneyBiometricDoNotExist || citizenOrAttorneyBiometricOptional))) &&
                                    <>
                                        <SubTitleContainer>
                                            <SubTitle>
                                                Documento do Cidadão
                                            </SubTitle>
                                        </SubTitleContainer>

                                        <DescContainer>
                                            <TextDesc>
                                                <i className="fas fa-times-circle" aria-hidden="true">
                                                    <img
                                                        src={InfoIcon}
                                                        style = {{ paddingBottom: '5px', marginRight: '9px' }}
                                                        alt="infoicon"
                                                    />
                                                </i>
                                                {(citizenOrAttorneyBiometricDoNotExist) && ('Como não foi possível realizar a biometria do cidadão, antes de continuar é necessário enviar um documento que identifique-o.')}
                                                {(!citizenOrAttorneyBiometricDoNotExist) && ('Antes de continuar é necessário enviar um documento que identifique o cidadão dono da conta gov.br.')}
                                            </TextDesc>
                                        </DescContainer>

                                        <DescContainer>
                                            <TextDesc>O documento deve estar no formato PDF e o tamanho não deve ultrapassar 5MB.</TextDesc>
                                        </DescContainer>

                                        <ContentContainer>
                                            <ContentContainer1WithoutMargin>
                                                <ContentContainerForm>                                                    
                                                    <SelectContainer>
                                                        <label className='title_input_file'> Tipo do documento </label>
                                                        <Select
                                                            options={documentTypeListOptions}
                                                            defaultValue={documentTypeListOptions && documentTypeListOptions[0]}
                                                            value={chosenDocumentType}
                                                            onChange={value => {
                                                                setChosenDocumentType(value);
                                                                removeUploadedFile();
                                                            }}
                                                            styles={SelecStyles}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: 6,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#CCCCCC',
                                                                    primary: '#1351B4'
                                                                },
                                                            })}
                                                            components={
                                                                {
                                                                    DropdownIndicator,
                                                                    IndicatorSeparator
                                                                }
                                                            }
                                                        />
                                                    </SelectContainer>
                                                    <FileInputDiv selectedType={true}>
                                                        <label className='title_input_file'> Documento </label>
                                                        <label className='content_input_file' htmlFor='file_input'>
                                                            <i className='fas fa-heartbeat' aria-hidden='true'>
                                                            <img src={UploadIcon} alt='uploadicon' />
                                                            </i>
                                                            Selecione o Documento
                                                        </label>
                                                        <input id='file_input' name='file_input' type='file' accept='application/pdf' onChange={(e) => uploadCitizenDocument(e)} />       
                                                        {msgFileError && (
                                                                            <span className='feedback danger' role='alert'>
                                                                            <i className='fas fa-times-circle' aria-hidden='true'>
                                                                                <img src={FailIcon} style={{ paddingBottom: '5px' }} alt='fail' />
                                                                            </i>
                                                                            <label>{msgFileError}</label>
                                                                            </span>
                                                                        )}         
                                                    </FileInputDiv> 
                                                </ContentContainerForm>
                                            
                                                <ContentContainer11> 
                                                    <FileContent>
                                                        {citizenUploadedDocumentation &&                                                    
                                                            <li style={{ listStyleType: 'none' }}>
                                                                <div className='br-list'>
                                                                    <Line>
                                                                    <Col1>
                                                                        <div className='br-item'>{citizenFileType}</div>
                                                                    </Col1>
                                                                    <Col2>
                                                                        <div className='br-item'>
                                                                        <Text2>{citizenFileName}</Text2>
                                                                        </div>
                                                                    </Col2>
                                                                    <Col3>
                                                                        <div className='br-item'>{citizenFileSize}</div>
                                                                    </Col3>
                                                                    <Col4>
                                                                        <div className='br-item'>
                                                                        <i className='fas fa-heartbeat' aria-hidden='true'>
                                                                            <img className='trash_icon' style={{ paddingBottom: '12px' }} src={TrashIcon} onClick={removeUploadedFile} alt='trashicon' />
                                                                        </i>
                                                                        </div>
                                                                    </Col4>
                                                                    </Line>
                                                                    <span className='br-divider'></span>
                                                                </div>
                                                            </li>
                                                        }
                                                    </FileContent>                                                                        
                                                </ContentContainer11>   
                                            </ContentContainer1WithoutMargin>            
                                        </ContentContainer>
                                    </>
                                }
                                </>
                            }

                            <ContentContainer>
                                <ContentContainer4>

                                </ContentContainer4>

                                <ContentContainer3>
                                    <ContentContainerButtons>
                                        <button className="br-button" type="button"
                                                onClick={setModalCancelVisible}>
                                            Cancelar
                                        </button>

                                        {person === "procurador" &&
                                            <button className="br-button secondary" type="button" disabled={citizenOrAttorneyBiometricValidated}
                                                    onClick={() => {
                                                        props.history.push(
                                                            "/dadosprocurador",
                                                            {
                                                                id_attendance: citizen.id_attendance,
                                                                cpf_attendant: citizen.cpf_attendant,
                                                                attendent: citizen.attendent,
                                                                person: citizen.person,
                                                                name_attorney: attorney.name_attorney,
                                                                cpf_attorney: attorney.cpf_attorney,
                                                                document_list: citizen.document_list,
                                                                documents: citizen.documents,
                                                                cpf_citizen: citizen.cpf,
                                                                document_type: citizen.document_type,
                                                                last_id_list: citizen.last_id_list
                                                            }
                                                        )
                                                    }}>
                                                Voltar
                                            </button>
                                        }
                                        {!fingerprint_verify &&
                                            <button className="br-button primary" type="submit">
                                                Avançar
                                            </button>
                                        }
                                        {fingerprint_verify && (
                                            <>
                                                {!(person === "procurador") ? ( //Fluxo do Cidadão
                                                    <button className="br-button primary" type="submit" disabled={!(citizenOrAttorneyBiometricValidated || citizenUploadedDocumentation)}>
                                                        {(citizenOrAttorneyBiometricValidated ? 'Avançar' : 'Iniciar a validação do atendente')}
                                                    </button>
                                                ) : ( //Fluxo do procurador
                                                    <button className="br-button primary" type="submit" disabled={!(citizenOrAttorneyBiometricValidated || citizenOrAttorneyBiometricDoNotExist || citizenOrAttorneyBiometricOptional)}>
                                                        {(citizenOrAttorneyBiometricValidated ? 'Avançar' : 'Iniciar a validação do atendente')}
                                                    </button>
                                                )}
                                            </>
                                        )}                                           
                                    </ContentContainerButtons>
                                </ContentContainer3>
                            </ContentContainer>
                        </form>
                    </GlobalContainer>    
                </>
            }
        </>
    );
}